// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-tag[data-v-2662f626] {\n  width: 70px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n}", ""]);
// Exports
module.exports = exports;
